<template>
  <el-row class="pm-table" v-loading="loading">
    <el-row v-if="loading || Ponds.length > 0">
      <el-alert
        ref="error_alert"
        v-if="unhandledErrorMessage !== ''"
        :title="unhandledErrorMessage"
        type="error"
      ></el-alert>
      <layout-toolbar justify="end" style="margin: 10px 10px;">
        <el-col :span="3" :lt="4" :md="4" :xl="3">
          <er-select
            v-model="pondsSelected"
            value-key="_id"
            :placeholder="$t('Ponds_select_pond_name')"
            filterable
            multiple
            collapse-tags
            @change="handleChangePond"
            :no-data-text="$t('Comn_no_data_connection')"
            size="mini"
            popper-class="pm-dropdown"
          >
            <template v-for="pond in pondsData">
              <el-option
                v-if="pond.pond_mothers.length > 0"
                :key="pond._id"
                :label="pond.title"
                :value="pond._id"
              ></el-option>
            </template>
          </er-select>
        </el-col>
        <el-col :span="3" :lt="4" :md="4" :xl="3">
          <er-select
            v-model="selectedPMIds"
            :showSelectAll="true"
            :disabled="pondsSelected.length === 0"
            collapse-tags
            multiple
            size="mini"
            :no-data-text="$t('Comn_no_data_connection')"
            :placeholder="'Pond Mother'"
            @change="handleChangePondMother"
            popper-class="pm-dropdown"
          >
            <el-option
              v-for="pm in selectedPondPMs"
              :key="pm._id"
              :value="pm._id"
              :label="pm.code"
              >{{ pm.code }}</el-option
            >
          </er-select>
        </el-col>
        <el-input-number
          v-model="pondMotherObj.settings.kg_dispense_time_sec"
          :disabled="pondsSelected.length === 0"
          :min="0"
          :placeholder="`${$t('Comn_enter')} (sec/kg)`"
          size="mini"
          :controls="false"
        ></el-input-number>
        <el-col :span="3" :lt="4" :md="3" :xl="2">
          <er-select
            v-model="pondMotherObj.mode"
            :disabled="pondsSelected.length === 0"
            :placeholder="$t('Mode')"
            :no-data-text="$t('Comn_no_data_connection')"
            size="mini"
            popper-class="pm-dropdown"
          >
            <el-option
              v-for="(value, key) in pondModesOfOperations"
              :label="$t(value.lang_key)"
              :key="key"
              :value="value.mode"
            ></el-option>
          </er-select>
        </el-col>
        <er-button
          btnType="save"
          size="mini"
          :showLabel="true"
          :showIcon="true"
          :disabled="isReadOnly"
          :loading="loading"
          @click="submitUpdatedDetails"
        ></er-button>
        <er-button
          btnType="cancel"
          size="mini"
          :showLabel="true"
          :disabled="isReadOnly"
          @click="initComponent"
        ></er-button>
      </layout-toolbar>
      <el-row class="pm-settings-table">
        <er-data-tables
          uniqueId="pm-settings__table"
          :tableData="dataValues"
          :key="$i18n.locale"
          :columns="tableColumns"
          :elTableProps="tableProps"
          :merge="{ startColumnNumber: 1, endColumnNumber: 1 }"
          :page-size="$constants.table['page-size']"
          :pagination-props="$constants.table['pagination-props']"
          :sortMethodForColumns="sortMethods()"
          :actionColumn="false"
          type="white-header-table"
        >
          <template v-slot:pond_id="{ row }">{{
            getPondName(row.data.pond_id)
          }}</template>

          <!-- <el-table-column :reserve-selection="true" type="selection" width="55"></el-table-column> -->

          <template v-slot:code="{ row }">{{ row.data.code }}</template>
          <template v-slot:title="{ row }">
            <el-input
              v-model="row.data.title"
              :placeholder="$t('enter_alias_name')"
              @change="handlePMChangeInTable($event, row.data)"
              size="mini"
            ></el-input>
          </template>

          <template v-slot:kg_dispense_time="{ row }">
            <el-input-number
              size="mini"
              :controls="false"
              :min="0"
              :disabled="isPMExistInSelectedPMs(row.data._id)"
              :placeholder="`(sec/kg)`"
              @change="handlePMChangeInTable($event, row.data)"
              v-model="row.data.settings.kg_dispense_time_sec"
            ></el-input-number>
          </template>

          <template v-slot:mode="{ row }">
            <er-select
              v-model="row.data.mode"
              :placeholder="$t('select_mode')"
              :disabled="isPMExistInSelectedPMs(row.data._id)"
              size="mini"
              @change="handlePMChangeInTable($event, row.data)"
              popper-class="mode-dropdown"
            >
              <template v-for="value in pondModesOfOperations">
                <el-option
                  :label="$t(value.lang_key)"
                  :key="value.mode"
                  :value="value.mode"
                ></el-option>
              </template>
            </er-select>
          </template>
        </er-data-tables>
      </el-row>
    </el-row>
    <er-no-ponds :tabData="tabData" :disabled="isReadOnly" v-else />
  </el-row>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import errorHandlerMixin from "@/mixins/errorHandlerMixin.js";
import PondMother from "@/model/pondmother";
import { permissionsToStringMap as permissions } from "@/middleware/pageAccessManager";
import RuleOption from "@/model/ruleOption";

export default {
  mixins: [errorHandlerMixin],
  data: function() {
    return {
      data: {},
      total: 0,
      isPondUnAssign: false,
      pondMotherObj: new PondMother(),
      pondsSelected: [],
      errMessagesObject: new PondMother(),
      selectedPMIds: [],
      editPMObj: {},
      tableEditPMObj: {},
      pondsData: [],
      loading: false,
      tableProps: {
        // border: true,
        size: "small",
        stripe: true,
        rowKey: this.getRowKey,
        defaultSort: {
          prop: "pond_id",
          order: "ascending"
        }
      },
      query: {
        get_all: true,
        order_by: null,
        order_type: null,
        un_assigned_only: false,
        location_id: null
      },
      editPermissions: {
        keyToValidateAccess: "PERMISSIONS",
        PERMISSIONS: [permissions.MANAGE_DEVICES, permissions.MANAGE_SCHEDULES]
      }
    };
  },
  props: {
    tabData: {
      default: {}
    }
  },
  computed: {
    ...mapGetters({
      PondMothers: "pondmother/getPondMothers",
      mapPondIdPond: "pond/getMapPondidPond",
      mapStIdSt: "shrimptalk/getMapStidSt",
      Ponds: "pond/getPonds",
      getPmIdPm: "pondmother/getPmIdPm"
    }),
    ...mapGetters("user", {
      isReadOnly: "isReadOnly"
    }),
    selectedPondPMs: function() {
      return this.pondsSelected
        .map(pond => this.mapPondIdPond.get(pond).pond_mothers)
        .flat(1);
    },
    selectedPondPMIds: function() {
      return this.selectedPondPMs.map(pm => pm._id);
    },
    pondModesOfOperations() {
      return {
        FARMER: { mode: "SCHEDULE", lang_key: "PM_schedule" },
        MANUAL: { mode: "BASIC", lang_key: "PM_sch_mode4" },
        SHRIMP_TALK: { mode: "AUTOMATIC", lang_key: "PM_automatic" }
      };
    },
    tableColumns() {
      return {
        pond_id: {
          prop: "pond_id",
          label: this.$t("Comn_pond_name"),
          sortable: "custom"
        },
        code: {
          prop: "code",
          label: this.$t("PM_id"),
          sortable: "custom"
        },
        kg_dispense_time: {
          prop: "settings.kg_dispense_time_sec",
          label: this.$t("PM_kg_dispensed_time_sec")
        },
        mode: {
          prop: "mode",
          label: this.$t("Mode")
        },
        title: {
          prop: "title",
          label: this.$t("Comn_alias_name")
        }
      };
    },
    dataValues() {
      return Object.values(this.data).sort((pm1, pm2) => {
        return this.$commonUtils.alphaNumericComparator(
          this.mapPondIdPond.get(pm1.pond_id).title,
          this.mapPondIdPond.get(pm2.pond_id).title
        );
      });
    },

    isTableEditted() {
      return Object.keys(this.tableEditPMObj).length > 0;
    },
    location() {
      return this.$store.getters["user/getCurrUserLocation"];
    },
    validationRules() {
      const deviceLangKey = "Comn_pond_mother";
      const fieldLangKey = {
        kg_dispense_time: "Comn_feed_dispensed_kg",
        title: "Comn_alias_name"
      };
      const rulesOptionsFunction = (
        fieldLangKey,
        itemTitle,
        minValue,
        maxValue
      ) => {
        return [
          RuleOption.createBasicRule(
            "REQUIRED",
            fieldLangKey,
            deviceLangKey,
            itemTitle
          ),
          RuleOption.createBasicRule(
            "MIN_EQUAL",
            fieldLangKey,
            deviceLangKey,
            itemTitle,
            minValue
          ),
          RuleOption.createBasicRule(
            "MAX_EQUAL",
            fieldLangKey,
            deviceLangKey,
            itemTitle,
            maxValue
          )
        ];
      };
      return payloadItem => {
        const itemTitle = payloadItem.title || payloadItem.code;
        return [
          {
            field: "kg_dispense_time",
            rules: rulesOptionsFunction(
              fieldLangKey.kg_dispense_time,
              itemTitle,
              20,
              300,
              fieldLangKey.kg_dispense_time
            )
          },
          {
            field: "title",
            rules: [
              RuleOption.createBasicRule(
                "REQUIRED",
                fieldLangKey.title,
                deviceLangKey,
                itemTitle
              )
            ]
          }
        ];
      };
    }
  },
  async mounted() {
    await this.initComponent();
  },
  methods: {
    ...mapActions({
      fetchAllPondMothers: "pondmother/fetchAllPondMothers",
      fetchAllShrimpTalks: "shrimptalk/fetchAllShrimpTalks",
      fetchAllPonds: "pond/fetchAllPonds",
      updatePMSettings: "pondmother/updatePMSettings"
    }),
    sortMethods() {
      return {
        pond_id: this.sortPondWise
      };
    },
    sortPondWise(a, b) {
      return this.$commonUtils.alphaNumericComparator(
        this.getPondName(a),
        this.getPondName(b)
      );
    },
    async initComponent() {
      this.pondsSelected = [];
      this.selectedPMIds = [];
      this.tableEditPMObj = [];
      this.editPMObj = {};
      this.pondMotherObj = new PondMother();
      await this.loadPMList();
    },
    getRowKey(row) {
      return row.pond_mother_id;
    },
    getPond(pond_id) {
      if (this.mapPondIdPond && this.mapPondIdPond.get(pond_id)) {
        return this.mapPondIdPond.get(pond_id);
      } else {
        return { pond_mothers: [] };
      }
    },
    handlePMChangeInTable(event, pm) {
      if (this.editPMObj[pm._id] == null) {
        this.$set(this.tableEditPMObj, pm._id, pm);
      }
    },
    handleCheckAllPMs(value) {
      this.selectedPMIds = value ? this.selectedPondPMIds : [];
      this.initEditPMObj(this.selectedPMIds, this.pondMotherObj);
      // this.isIndeterminatePMs = false;
    },
    initEditPMObj(pmIdArr, pondMotherObj) {
      this.editPMObj = {};
      if (pmIdArr.length > 0) {
        pmIdArr.forEach(pmId => {
          this.editPMObj[pmId] = this.$lodash.cloneDeep(
            this.getPmIdPm.get(pmId)
          );
        });
      }
    },
    isPMExistInSelectedPMs(pmId) {
      return this.selectedPMIds.indexOf(pmId) > -1;
    },
    handleChangePond(pondIdArr) {
      if (pondIdArr.length > 0) {
        this.pondMotherObj = new PondMother();
        this.handleCheckAllPMs(true);
        Object.keys(this.tableEditPMObj).forEach(pmId => {
          this.$set(
            this.data,
            pmId,
            this.$lodash.cloneDeep(this.getPmIdPm.get(pmId))
          );
        });
        this.tableEditPMObj = {};
      } else {
        this.handleCheckAllPMs(false);
      }
    },
    handleChangePondMother(pmIdArr) {
      if (pmIdArr.length === 0) {
        this.handleCheckAllPMs(false);
      } else {
        this.pondMotherObj = new PondMother();
        this.initEditPMObj(pmIdArr, this.pondMotherObj);
      }
    },
    async submitUpdatedDetails() {
      const payLoadObj = {};
      // values editted in the select element
      Object.values(this.editPMObj).forEach(pm => {
        if (pm != null && typeof pm !== "undefined") {
          payLoadObj[pm._id] = {
            title: this.pondMotherObj.title || pm.title,
            code: pm.code,
            pond_mother_id: pm._id,
            kg_dispense_time:
              this.pondMotherObj.settings.kg_dispense_time_sec ||
              pm.settings.kg_dispense_time_sec,
            mode: this.pondMotherObj.mode || pm.mode,
            shrimp_talk_id: pm.shrimp_talk_id
          };
        }
      });

      Object.values(this.tableEditPMObj).forEach(pm => {
        if (payLoadObj[pm._id] == null) {
          payLoadObj[pm._id] = {
            title: pm.title,
            pond_mother_id: pm._id,
            code: pm.code,
            kg_dispense_time: pm.settings.kg_dispense_time_sec,
            mode: pm.mode,
            shrimp_talk_id: pm.shrimp_talk_id
          };
        }
      });

      const errors = [];
      try {
        console.log("hit edit");
        this.isEditable(this.tabData);

        if (this.selectedPMIds.length > 0) {
          if (
            !this.pondMotherObj.settings.kg_dispense_time_sec &&
            !this.pondMotherObj.mode
          ) {
            throw {
              type: "FAIL_TO_SAVE",
              errors: [
                {
                  message: `${this.$t("enter_kg_dispensed_time_sec")} ${this.$t(
                    "or_lower_case"
                  )} ${this.$t("select_mode")}`
                }
              ]
            };
          }
        }

        // this.isEditable(this.editPermissions);

        const arrPayload = Object.values(payLoadObj);

        // "Please Select aleast one Pond Mother"
        if (this.PondMothers.length === 0) {
          return;
        }
        if (arrPayload.length === 0) {
          throw {
            type: "FAIL_TO_SAVE",
            errors: [
              {
                message: this.$t("Comn_no_changes_found", {
                  item: this.$t("Comn_pond_mother")
                })
              }
            ]
          };
        }
        const errors = arrPayload.reduce((acc, payloadItem) => {
          acc.push(
            ...this.ruleValidator(
              payloadItem,
              this.validationRules(payloadItem),
              "REQUIRED"
            )
          );
          console.log(acc);
          return acc;
        }, []);

        if (errors.length > 0) {
          throw {
            type: "FAIL_TO_SAVE",
            errors
          };
        }
        this.loading = true;
        const payload = Object.values(payLoadObj);
        // {pond_mothers:newSelectedPMIds}
        this.errorMessagesObject = new PondMother();
        // eslint-disable-next-line no-unused-vars
        const response = await this.updatePMSettings(payload);

        this.errorMessagesObject = new PondMother();
        this.$notify({
          title: this.$t("Usrs_success_msg"),
          // message: response.message,
          message: this.$t("PM_upd_success"),
          duration: 5000,
          type: "success"
        });
        await this.initComponent();
      } catch (err) {
        console.log(err);
        this.errorMessages(err, true);
      } finally {
        this.loading = false;
      }
    },
    getPondName(pondId) {
      if (pondId !== "") {
        return (this.mapPondIdPond.get(pondId) || { title: "Not Found" }).title;
      }
    },
    async loadPMList() {
      this.loading = true;
      try {
        this.query.status = ["ACTIVE"];
        await this.fetchAllPonds({
          location_id: this.location._id,
          status: ["ACTIVE", "INACTIVE"],
          get_all: true
        });
        this.pondsData = this.$lodash
          .cloneDeep(this.Ponds)
          .sort((a, b) =>
            this.$commonUtils.alphaNumericComparator(a.title, b.title)
          );
        let response = await this.fetchAllPondMothers({
          location_id: this.location._id,
          get_all: true
        });
        this.PondMothers.forEach(pm => {
          // this.data[pm._id] = pm;
          /* eslint-disable */
          const pmIsAssignedToPond =
            pm.hasOwnProperty("pond_id") &&
            pm.pond_id != null &&
            pm.pond_id !== "";
          pm.mode = pm.mode
            ? pm.mode
            : this.pondModesOfOperations[pm.managed_by];
          if (pmIsAssignedToPond) this.$set(this.data, pm._id, pm);
        });
        this.total = response.totalPMs;
        response = await this.fetchAllShrimpTalks({
          location_id: this.location_id,
          get_all: true
        });
      } catch (err) {
        this.errorMessages(err, true);
      } finally {
        this.loading = false;
      }
    },
    handleAddPondClick() {
      try {
        this.isEditable(this.tabData);
        this.$router.push("map-view");
      } catch (error) {
        this.errorMessages(error, true);
      }
    }
  }
};
</script>

<style lang="scss">
.pm-dropdown {
  .el-select-dropdown__item {
    // font-size: 11px;
    @include responsiveProperty(
      font-size,
      $app_font_size_small,
      $app_font_size_1,
      $app_font_size_2
    );
    height: 20px;
    display: flex;
    align-items: center;
  }
}
.mode-dropdown {
  .el-select-dropdown__item {
    // font-size: 11px;
    @include responsiveProperty(
      font-size,
      $app_font_size_small,
      $app_font_size_1,
      $app_font_size_2
    );
    height: 20px;
    display: flex;
    align-items: center;
  }
  .el-select-dropdown {
    min-width: 120px !important;
  }
  min-width: 120px !important;
}
.pm-table {
  $input_width: 200px;

  .big-input-container {
    .el-select {
      width: 150px;
    }
  }
  .el-input__inner {
    font-size: 11px !important;
  }

  .settings-post-header-center {
    display: flex;
    justify-content: space-evenly;
  }
  .pm-settings-table {
    padding: 0 12px;
    .el-select {
      .el-input--mini {
        width: 120px;
      }
    }
    .el-input__inner {
      width: 120px;
      font-size: 11px !important;
    }
    .el-input-number--mini {
      width: 120px;
    }
    .el-input-number {
      .el-input--mini {
        .el-input__inner {
          width: 80px;
          font-size: 11px !important;
        }
      }
    }
  }
  .pm-table__header {
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;

    .post-header-pm-selection {
      .el-input--mini {
        max-width: 160px;
      }
    }
    // background: white;
  }
  .filters {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    & > div:nth-child(n + 1) {
      margin-right: 10px;
    }
    .input_all_kg_disp {
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      overflow: hidden;
      height: 30px;
      line-height: 32px;
      &:after {
        position: absolute;
        content: "";
        right: 0px;
        width: 20px;
        height: 32px;
        background-color: white;
        z-index: 9;
      }
      &.is-disabled {
        &:after {
          background-color: #f5f7fa;
          cursor: not-allowed;
          color: #c0c4cc;
        }
      }

      .el-input__inner {
        border: none;
        border-radius: unset;
        padding: 0px 0px 0px 15px;
      }
    }
  }
  .table {
    margin: 10px;
  }
  .el-pagination__sizes {
    .el-input--mini .el-input__inner {
      height: 22px;
      line-height: 22px;
    }
  }
  .el-pagination__total {
    margin-left: 20px;
  }
  .el-pagination {
    padding-top: 10px;
    padding-bottom: 10px;
    .el-pagination__editor {
      .el-input__inner {
        width: 46px;
      }
    }
  }
  .pm-tag-list {
    display: flex;
    flex-direction: row;
    margin: 10px;
    box-sizing: border-box;
  }
  .el-select-dropdown__item {
    font-size: 11px !important;
  }
}
</style>